import TFWebLog from './components/TFWebLog/js/TFWebLog/index.js';

export default TFWebLog;


// WEBPACK FOOTER //
// ./src/index.js